import { Pipe, PipeTransform } from '@angular/core';
import { ELang } from '@atlas-workspace/shared/models';

@Pipe({ name: 'excludeFinnish', standalone: true })
export class ExcludeFinnishPipe implements PipeTransform {
  transform(value: { key: string; value: string }[]): { key: string; value: string }[] {
    return value.filter((item) => item.value !== ELang.Finnish);
  }
}
